import {Component, computed, inject, input} from '@angular/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {TranslatePipe} from '@ngx-translate/core';
import {LegalEntityStore} from '../../services/legal-entity-store';
import {LegalEntitySummary} from '../../../../../api/models';
import {FormControl} from '@angular/forms';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';

@Component({
  selector: 'elcia-legal-entity-dropdown',
  imports: [
    Dropdown,
    TranslatePipe,
    MultiDropdown,
  ],
  templateUrl: './legal-entity-dropdown.html',
  styleUrl: './legal-entity-dropdown.scss',
})
export class LegalEntityDropdown {
  legalEntityStore = inject(LegalEntityStore);
  legalEntities = computed<LegalEntitySummary[]>(() => this.legalEntityStore.legalEntities());
  control = input.required<FormControl>();
  isMulti = input(false);
}
